import VoucherCodes from "../../components/voucher-codes";
import HeaderPage from "../../components/lines-managements/header/HeaderPage";
import useCan from "../../components/users/permissions/useCan";

const VoucherCodesPage: React.FC = () => {
  const can = useCan("vouchers.vouchercode.create");
  return (
    <>
      <HeaderPage
        {...(can && {
          link: {
            to: "add",
            children: "Shto vaucher te ri",
            state: ["Esim", "Voucher Codes", "Shto vaucher te ri"]
          }
        })}
      />
      <VoucherCodes />
    </>
  );
};

export default VoucherCodesPage;
